// src/utils/slug.ts
export type GenerateSlugOptions = {
  maxLength?: number; // デフォルト 80
};

/**
 * タイトルからURLセーフなslugを生成する共通関数。
 * - 全角・半角の正規化 (NFKC)
 * - 改行除去、trim、lowercase
 * - 空白/アンダースコア→ハイフン
 * - 許可文字以外を除去
 * - 連続ハイフンの圧縮、両端ハイフン除去
 * - 空になった場合は "memo-1" を返す
 */
export function generateSlug(input: string | undefined | null, opts: GenerateSlugOptions = {}): string {
  const maxLength = opts.maxLength ?? 80;
  if (!input) return "memo-1";

  let s = input
    .normalize("NFKC")
    .replace(/\r?\n/g, " ")
    .trim()
    .toLowerCase();

  // 空白・アンダースコアはハイフンへ
  s = s.replace(/[\s_]+/g, "-");

  // 許可: a-z0-9, ハイフン, 日本語(ひらがな/カタカナ/長音/漢字)
  // ※必要に応じて許可レンジは調整してください
  s = s.replace(/[^a-z0-9\-ぁ-んァ-ヶｦ-ﾟ一-龥ー]/g, "");

  // 連続ハイフンを1つに
  s = s.replace(/\-+/g, "-");

  // 先頭/末尾のハイフン除去
  s = s.replace(/^\-+|\-+$/g, "");

  if (!s) s = "memo-1";

  // 長すぎる場合はトリム
  if (s.length > maxLength) {
    s = s.slice(0, maxLength);
    // 末尾がハイフンで終わらないように調整
    s = s.replace(/\-+$/g, "");
    if (!s) s = "memo-1";
  }

  return s;
}
